import {Component, Inject, Input} from '@angular/core';
import { Reservation } from '../../api/model/reservation/reservation.model';
import {User} from '../../api/model/user/user.model';
import {IMessage} from "../../api/interfaces/Messages/IMessage";
import {MessagesUtil} from "../../common/messages.util";
import {ReservationErrorMessageKeys} from "../../api/model/errors/reservation-error-message-keys.model";
import {APP_CONFIG} from "../../api/config/app.config";
import {IAppConfig} from "../../store/interfaces/IAppConfig";
import {SiteURL, SiteURLUtils} from "../../common/site.url.utils";

@Component({
  selector: 'user-reservation-check',
  templateUrl: './user-reservation-check.component.html',
  styleUrls: ['./user-reservation-check.component.scss']
})
export class UserReservationCheckComponent {
  @Input() messages;
  private _member: User;
  private _reservation: Reservation;
  message: IMessage;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig) { }

  get reservation(): Reservation {
    return this._reservation;
  }

  @Input() set reservation(value: Reservation) {
    this._reservation = value;
    this.initMessage();
  }
  get member(): User {
    return this._member;
  }

  @Input() set member(value: User) {
    this._member = value;
    this.initMessage();
  }

  initMessage() {
    this.message = null;
    if (!this._reservation || !this._member) {return}
    const param = SiteURLUtils.getLocalizedSiteUrl(this.appConfig, SiteURL.SIGN_IN);
      if (this._member.isExplicit() && (this._member.rewardsClubNumber !== this._reservation.guest.rewardsClubNumber)) {
        this.message = MessagesUtil.toErrorMessage(ReservationErrorMessageKeys.ERROR_ACCESS, [param], true);
      }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/user-reservation-check/user-reservation-check.component.ts